<template>
  <section>
    <b-field label="Selecciona un periodo">
      <b-datepicker
        placeholder="Click para seleccionar..."
        v-model="fechasSeleccionadas"
        range
        @input="onFechaSeleccionada"
      >
      </b-datepicker>
    </b-field>
  </section>
</template>
<script>
export default {
  name: "BusquedaEnFecha",

  data: () => ({
    fechasSeleccionadas: [],
  }),
  // En el componente BusquedaEnFecha
methods: {
  onFechaSeleccionada() {
    // Obtener las fechas seleccionadas
    const [fechaIniciox, fechaFinx] = this.fechasSeleccionadas;

    // Emitir el evento con las fechas tal como son, sin añadir la hora
    this.$emit("seleccionada", [fechaIniciox, fechaFinx]);
  }
}

};
</script>